module.exports = "/_next/static/images/img_banner_gardasil-d5d0c43068f7bb2041033be5bcf22f81.png";